import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Building2, Store, Trees, ArrowRight } from "lucide-react";
import { fadeUp, stagger } from "@/lib/motion";

const TYPES = [
  {
    key: "house",
    label: "House",
    sub: "Villas & family homes",
    icon: Home,
    to: "/buy",
    img: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?crop=entropy&cs=srgb&fm=jpg&w=800&q=70",
  },
  {
    key: "apartment",
    label: "Apartment",
    sub: "Condos & penthouses",
    icon: Building2,
    to: "/map-search?q=Apartment",
    img: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?crop=entropy&cs=srgb&fm=jpg&w=800&q=70",
  },
  {
    key: "commercial",
    label: "Commercial",
    sub: "Offices & retail",
    icon: Store,
    to: "/commercial",
    img: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&w=800&q=70",
  },
  {
    key: "land",
    label: "Land",
    sub: "Plots & farmland",
    icon: Trees,
    to: "/land",
    img: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?crop=entropy&cs=srgb&fm=jpg&w=800&q=70",
  },
];

export const BrowseByType = () => {
  const navigate = useNavigate();
  return (
    <section className="bg-background py-12 sm:py-16" data-testid="browse-type-section">
      <div className="abay-container">
        <div className="flex items-end justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-foreground sm:text-3xl">Browse by Property Type</h2>
            <p className="mt-2 text-sm text-muted-foreground sm:text-base">Jump straight to the kind of property you want.</p>
          </div>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mt-6 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4"
        >
          {TYPES.map((t) => (
            <motion.button
              key={t.key}
              variants={fadeUp}
              type="button"
              onClick={() => navigate(t.to)}
              data-testid={`browse-type-${t.key}`}
              className="tap-press group relative aspect-[4/5] overflow-hidden rounded-2xl text-left shadow-[var(--shadow-sm)] transition-shadow duration-200 hover:shadow-[var(--shadow-md)] sm:aspect-[4/3]"
            >
              <img
                src={t.img}
                alt={t.label}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(9,20,48,0.88)_0%,rgba(9,20,48,0.35)_55%,rgba(9,20,48,0.08)_100%)]" />
              <span className="absolute left-3 top-3 flex h-10 w-10 items-center justify-center rounded-xl bg-white/15 text-white ring-1 ring-white/25 backdrop-blur-sm">
                <t.icon className="h-5 w-5" />
              </span>
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-2 p-4">
                <span>
                  <span className="block text-lg font-bold text-white">{t.label}</span>
                  <span className="block text-xs font-medium text-white/80">{t.sub}</span>
                </span>
                <ArrowRight className="h-5 w-5 shrink-0 text-white transition-transform duration-200 group-hover:translate-x-0.5" />
              </div>
            </motion.button>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
